import { Icon, IconName, IconSize, InputProps, ProColors } from '../../../aura';

function ValidInputRightComponent() {
  return (
    <Icon
      size={IconSize.SMALL}
      name={IconName.TW_PRO_CHECK_MARK}
      color={ProColors.teal[600]}
    />
  );
}

export function InvalidInputRightComponent() {
  return (
    <Icon
      size={IconSize.SMALL}
      name={IconName.TW_PRO_CLOSE}
      color={ProColors.coral[600]}
    />
  );
}

export function getExtraInputProps(
  t: (s: string) => string,
  hasValue: boolean,
  isValid: boolean,
  showErrors: boolean,
): Partial<InputProps> {
  if (isValid) {
    return {
      innerRightComponent: <ValidInputRightComponent />,
    };
  }

  if (!showErrors) {
    return {};
  }

  if (!hasValue) {
    return {
      subText: t('required'),
      subTextFlavor: 'error',
      innerRightComponent: <InvalidInputRightComponent />,
    };
  }

  return {
    subText: t('invalid'),
    subTextFlavor: 'error',
    innerRightComponent: <InvalidInputRightComponent />,
  };
}
